import { Injectable, } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable()
export class ModalCadastroParceiroPrService {

  constructor(private client : HttpClient) { }

  sendCadastro(nome:string,cpf: string, email:string, telefone:string, cidade:string, uf: string, pix: string):Observable<any>{

    let cad = {
      email:email,
      nome:nome,
      cpfcnpj:cpf,
      telefone:telefone,
      municipio:cidade,
      uf:uf,
      pix:pix,
      codigo:""
    };

    return this.client.post(environment.urlServiceNotification + "registraparceiropr", cad, {      
      headers: new HttpHeaders({
        'Content-Type': 'application/json; charset=utf-8',
            'Accept-Language': 'pt-BR' 
        })
    })
  }
}
